import React, { ReactElement } from 'react'
import {  makeStyles, Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import KTR100 from '../Clampexsets/KTR100';
import KTR150 from '../Clampexsets/KTR150';

const useStyle = makeStyles({
    card: {
      margin: "10px"
    }
  });

export default function NotSelfCentering(): ReactElement {
    const classes = useStyle();
    const { formatMessage: f } = useIntl();

    return (
        <React.Fragment>
            <h2>
                {f({id:'app.notselfcentered'})}
            </h2>
        <Grid container style={{ marginTop: "20px" }} justify="center">
          <Grid item>
            <KTR100 className={classes.card}/>
          </Grid>
          <Grid item >
            <KTR150 className={classes.card}/>
          </Grid>
        </Grid>
      </React.Fragment>
    )
}
